import { Chip } from "@mui/material";
import { useTranslation } from "i18n-fe";
import { PROBLEM_KINDS, joinCnoList, placeByRulesProblems } from "../util/placeByRules";

// #3651 -- the ONE short reason a class cannot be placed, for the Classes page's
// "Placing problems" filter. It is the FIRST problem placeByRulesProblems finds
// (the same mapping PlaceByRulesProblems prints in full in the class drawer, which
// the chip opens), cut to a few words. One line: noWrap + ellipsis, the full text
// in the title tooltip. Every i18n key is static.
export default function PlaceProblemChip({ problem, onOpen, sx, ...chipProps }) {
  const { t } = useTranslation("scoreadmin");
  const first = placeByRulesProblems({ ...problem, placeable: false })[0];
  if (!first) return null;

  const cnoLabel = (r) =>
    r.competitorNumber != null ? t("placeByRules.cno", { cno: r.competitorNumber }) : t("placeByRules.rideWithoutCno");
  const cnos = joinCnoList(first.rides, cnoLabel, t("placeByRules.and"));

  let label;
  switch (first.kind) {
    case PROBLEM_KINDS.MANUAL_RIDES:
      label = t("ring.placeProblemChip.manualRides");
      break;
    case PROBLEM_KINDS.NOT_FINISHED:
      label = t("ring.placeProblemChip.notFinished", { cnos });
      break;
    case PROBLEM_KINDS.TIED:
      label = t("ring.placeProblemChip.tied");
      break;
    case PROBLEM_KINDS.JUDGE_PLACE_MISSING:
      label = t("ring.placeProblemChip.judgePlaceMissing");
      break;
    case PROBLEM_KINDS.JUDGE_PLACE_DUPLICATE:
      label = t("ring.placeProblemChip.judgePlaceDuplicate");
      break;
    case PROBLEM_KINDS.ALREADY_PLACED:
      label = t("ring.placeProblemChip.alreadyPlaced");
      break;
    case PROBLEM_KINDS.NO_RIDES:
      label = t("ring.placeProblemChip.noRides");
      break;
    case PROBLEM_KINDS.NO_SCORES:
      label = t("ring.placeProblemChip.noScores");
      break;
    case PROBLEM_KINDS.TOO_LARGE:
      label = t("ring.placeProblemChip.tooLarge");
      break;
    default:
      label = t("ring.placeProblemChip.other");
  }

  return (
    <Chip
      size="small"
      color="error"
      variant="outlined"
      clickable
      label={label}
      title={label}
      onClick={(e) => {
        e.stopPropagation();
        onOpen?.();
      }}
      sx={{ maxWidth: "100%", "& .MuiChip-label": { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, ...sx }}
      {...chipProps}
    />
  );
}
